<template>
  <div class="app d-none">
    <nav style="display: none;">
      <router-link to="/" class="nav-link">Home</router-link>
      <router-link to="/register" class="nav-link">Register Student</router-link>
      <router-link to="/verify" class="nav-link">Clock In/Out</router-link>
    </nav>
    <router-view></router-view>
  </div>
</template>

<style>
.app {
  font-family: Arial, sans-serif;
}

nav {
  padding: 20px;
  background: #f5f5f5;
  text-align: center;
  box-shadow: 0 2px 4px rgba(0,0,0,0.1);
}

.nav-link {
  display: inline-block;
  margin: 0 15px;
  padding: 10px 20px;
  text-decoration: none;
  color: #2c3e50;
  border-radius: 4px;
  transition: all 0.3s ease;
}

.nav-link:hover {
  background: #e0e0e0;
}

.router-link-active {
  color: #42b983;
  background: #e8f5e9;
}
</style> 